import React, { Component } from 'react'
import { Spin, Modal, notification } from 'antd'
import _ from 'lodash'
import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import { __ } from '@wordpress/i18n'

const VC_CONFIG = _.get(window, 'VC_CONFIG', {})

/**
 * 大平台載具歸戶 - 處理頁面 (Process)
 * 
 * 此頁面接收 PHP (init.php) 驗證後的 redirect，處理後續流程：
 * - 成功: ?token=xxx&ban=xxx&verified=1 → 保存 token → 檢查登入 → 導向
 * - 失敗: ?error=xxx → 顯示錯誤訊息
 */
export default class UserBigPlatformProcess extends Component {
  state = {
    isProcessing: false,
    errorMessage: null,
  }

  componentDidMount() {
    // 檢查是否有錯誤參數
    const error = this.getParameterByName('error')
    if (error) {
      return this.showErrorAndRedirect(decodeURIComponent(error))
    }

    // 檢查驗證成功參數
    const verified = this.getParameterByName('verified')
    const token = this.getParameterByName('token')
    const ban = this.getParameterByName('ban')

    if (verified === '1' && token && ban) {
      this.setState({ isProcessing: true }, () => {
        this.handleVerifiedCallback(token, ban)
      })
    } else {
      // 無效的訪問
      this.showErrorAndRedirect(
        __('無效的頁面訪問，請從正確管道進行載具歸戶。', 'cec-plugin-stores')
      )
    }
  }

  /**
   * 從 URL 取得參數
   */
  getParameterByName = (name, url) => {
    if (!url) url = window.location.href
    name = name.replace(/[\[\]]/g, '\\$&')
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    const results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  /**
   * 處理驗證成功的回調
   * PHP 已完成 API 驗證，這裡只需保存 token 並檢查登入狀態
   */
  handleVerifiedCallback = (token, ban) => {
    console.log('處理驗證成功回調:', { token, ban })

    // 保存 token 到 localStorage
    AppHelper.setLocalStorage('big-platform-token', token)
    AppHelper.setLocalStorage('big-platform-ban', ban)

    console.log('Token 已保存至 storage')

    // 檢查用戶登入狀態
    this.checkLoginStatus()
  }

  /**
   * 檢查用戶登入狀態
   */
  checkLoginStatus = () => {
    const authorization = _.get(this.props, 'auth.authorization')
    const isLogin = _.get(this.props, 'auth.isLogin', false)

    console.log('檢查登入狀態:', { isLogin, hasAuth: !!authorization })

    if (!isLogin || !authorization) {
      // 未登入，保存目標頁面並導向登入
      this.redirectToLogin()
    } else {
      // 已登入，直接導向載具綁定頁
      this.redirectToCarrierBinding()
    }
  }

  /**
   * 導向登入頁面
   */
  redirectToLogin = () => {
    // 保存目標頁面路徑，登入後會導回來
    AppHelper.setLocalStorage('to-href', '/carrier-binding')
    AppHelper.setLocalStorage('from-big-platform', 'true')

    notification.info({
      message: __('請先登入', 'cec-plugin-stores'),
      description: __('載具歸戶需要登入會員帳號', 'cec-plugin-stores'),
      duration: 2,
    })

    // 延遲導向，讓用戶看到提示訊息
    setTimeout(() => {
      // 取得 CC 登入 URL
      this.getCCLoginUri()
    }, 1500)
  }

  /**
   * 取得 CC 登入 URL
   */
  getCCLoginUri = () => {
    whttp.get(API_HOST + `/api/account/cc/login`, {}, (state, res) => {
      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res

      if (state === false || code !== 200) {
        return this.showErrorAndRedirect(
          __('登入頁面讀取失敗，請稍候再試。', 'cec-plugin-stores')
        )
      }

      console.log('導向 CC 登入頁:', data.uri)
      window.location.href = data.uri
    })
  }

  /**
   * 導向載具綁定頁面
   */
  redirectToCarrierBinding = () => {
    notification.success({
      message: __('驗證成功', 'cec-plugin-stores'),
      description: __('即將前往載具綁定頁面', 'cec-plugin-stores'),
      duration: 1,
    })

    setTimeout(() => {
      window.location.href = `${VC_CONFIG.INDEX_URL}/carrier-binding`
    }, 1000)
  }

  /**
   * 顯示錯誤訊息並導回首頁
   */
  showErrorAndRedirect = (message) => {
    this.setState({ isProcessing: false })

    Modal.error({
      title: __('載具歸戶失敗', 'cec-plugin-stores'),
      content: message,
      onOk: () => {
        // 清除相關 storage
        AppHelper.removeLocalStorage('big-platform-token')
        AppHelper.removeLocalStorage('big-platform-ban')
        AppHelper.removeLocalStorage('from-big-platform')
        window.location.href = VC_CONFIG.INDEX_URL
      },
    })
  }

  render() {
    const { isProcessing } = this.state

    return (
      <div
        style={{ height: '350px' }}
        className='jumbotron d-flex align-items-center'>
        <div className='container text-center'>
          {isProcessing ? (
            <div>
              <Spin size='large' />
              <h4 className='mt-4'>
                {__('正在處理載具歸戶請求...', 'cec-plugin-stores')}
              </h4>
              <p className='text-muted'>
                {__('請稍候，不要關閉此頁面', 'cec-plugin-stores')}
              </p>
            </div>
          ) : (
            <div>
              <h4>{__('處理中...', 'cec-plugin-stores')}</h4>
            </div>
          )}
        </div>
      </div>
    )
  }
}

// 編輯器組件
export class UserBigPlatformProcessEditor extends Component {
  render() {
    return (
      <div className='vu-blocks-editor'>
        <h2>大平台載具歸戶 - 處理頁面</h2>
        <p>接收 PHP 驗證後的 redirect，處理 token 保存與登入檢查</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-big-platform-process.js